<template>
  <div class="filter-field filter-checkbox">
    <div class="filter-field__control">
      <div class="custom-control custom-checkbox">
        <input
          :id="fieldId"
          class="custom-control-input"
          type="checkbox"
          :checked="checked"
          :disabled="disabled"
          @change="$emit('input', $event.target.checked ? '1' : '')"
        >
        <label class="custom-control-label" :for="fieldId">{{ label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * One independent boolean filter as a single checkbox — additive on top of whatever else is
 * selected (unlike FilterRadioGroup, which is a single-value, mutually-exclusive choice).
 * `value` / `input` travel as '' (off) / '1' (on) to match useServerList's plain-scalar
 * extraFilters convention (a real JS boolean default would always be sent, see useServerList.js).
 * Pair with FilterBar + a scalar useServerList extraFilter.
 */
export default {
  name: 'FilterCheckbox',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Boolean, Number], default: '' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    checked() {
      return this.value === '1' || this.value === true || this.value === 1
    },
    fieldId() {
      return `filter-cb-${this.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`
    }
  }
}
</script>

<style scoped>
.filter-checkbox {
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/filters/FilterCheckbox.vue